import { validationRules } from '../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'

export const propertyOwnerGarageRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    constructionYear: validationRules.constructionYear,
    constructionLastModernization: validationRules.constructionLastModernization,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  costs: {
    courtageNote: validationRules.courtageNote,
    courtage: validationRules.courtage,
    baseRent: validationRules.baseRent,
    additionalCosts: validationRules.additionalCosts,
  },
  otherFacilities: {
    heightGarage: validationRules.heightGarage,
    widthGarage: validationRules.widthGarage,
    lengthGarage: validationRules.lengthGarage,
    usableArea: validationRules.usableGarageArea,
  },
}
